import { TimeRangeConfig } from '@/api/generated/model';
import { PARAMS_KEY_EXPLORE_KEY, PARAMS_KEY_PAGE_TIME_RANGE, PARAMS_KEY_REPORT_SHARED_TIME_RANGE } from '@/constants/route-params-keys';
import { useGlobalFiltersContext } from '@/contexts/filters/filter-context';
import { useNebulyPageStableNow } from '@/domains/pages/hooks/use-nebuly-page-stable-now';
import { resolveGlobalFilterPickerTimeRange } from '@/hooks/use-page-scoped-global-filter-time-range.utils';
import { useSessionStorageListener } from '@/hooks/useSessionStorageListener';
import { getDateTRangeFromKindWithoutCustom } from '@/utils/get-date-range-from-kind';
import { usePathname, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
export function usePageScopedGlobalFilterTimeRange(): TimeRangeConfig | undefined {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    timeRange
  } = useGlobalFiltersContext();
  const stableNow = useNebulyPageStableNow();
  const stableNowKey = stableNow.getTime();
  const liveActivityCohortsTimeRange = useMemo(() => getDateTRangeFromKindWithoutCustom('12_months'), []);

  // Explore's calendar is persisted in session storage under the explore key, not in the URL
  // or the global filters context, so read it the same way the Explore page itself does.
  const exploreKey = searchParams.get(PARAMS_KEY_EXPLORE_KEY);
  const exploreConfig = useSessionStorageListener<{
    time_range?: TimeRangeConfig;
  }>(exploreKey);
  return useMemo(() => resolveGlobalFilterPickerTimeRange({
    pathname,
    liveActivityCohortsTimeRange,
    reportSharedTimeRangeParam: searchParams.get(PARAMS_KEY_REPORT_SHARED_TIME_RANGE),
    pageTimeRangeParam: searchParams.get(PARAMS_KEY_PAGE_TIME_RANGE),
    exploreTimeRange: exploreConfig?.time_range,
    contextTimeRange: timeRange,
    now: stableNow
  }), [pathname, liveActivityCohortsTimeRange, searchParams, timeRange, exploreConfig, stableNowKey]);
}